import React from 'react';
import FormContainer from './components/FormContainer';
import ErrorBoundary from './components/ErrorBoundary';
import { mockFormData } from './data/mockData';
import { FormValues } from './types/FormTypes';
import { submitFormData } from './services/apiService';

function App() {
  const handleSubmit = async (values: FormValues) => {
    console.log('=== FORM SUBMIT BUTTON CLICKED ===');
    console.log('Form submitted with values:', values);
    
    try {
      await submitFormData(values);
      console.log('Form submitted successfully to API');
      // Redirect to Baserow gallery after successful submission
      window.location.href = 'https://baserow.io/public/gallery/v_cv-iFgs9o28D0_XU1LOWLAhLm10plbGqMpuZkYW1s';
    } catch (error) {
      console.error('Failed to submit form:', error);
      // You could show a toast notification or error message here
    }
  };

  return (
    <div className="App">
      <ErrorBoundary>
        <FormContainer
          title={mockFormData.title}
          fields={mockFormData.fields}
          submitText={mockFormData.submitText}
          onSubmit={handleSubmit}
        />
      </ErrorBoundary>
    </div>
  );
}

export default App;
